import Service from 'react-reservice';

import { DEFAULT_PAGE_SIZE, DEFAULT_SYMBOL_TYPES } from './constants';
import { ECompanyExposureSymbolType, EDealerTab, ICompanyExposurePositionMap, ICompanyExposureRowData } from './types';
import { filterCompanyExposureBySearch } from './utils';

export interface IDealerContext {
  loading: boolean;
  selectedTab: EDealerTab;

  allCompanyExposure: ICompanyExposureRowData[];
  displayCompanyExposure: ICompanyExposureRowData[];
  companyExposureSearchResult: ICompanyExposureRowData[];
  allSymbolMap: Map<string, ICompanyExposurePositionMap>;

  showTypeFilter: boolean;
  checkedTypes: ECompanyExposureSymbolType[];
  search?: string;
  pagination: {
    pageIndex: number;
    pageSize: number;
  };
}

const defaultContext: IDealerContext = {
  loading: false,
  selectedTab: EDealerTab.COMPANY_EXPOSURE,

  allCompanyExposure: [],
  displayCompanyExposure: [],
  companyExposureSearchResult: [],
  allSymbolMap: new Map(),

  showTypeFilter: false,
  checkedTypes: DEFAULT_SYMBOL_TYPES,
  search: undefined,
  pagination: {
    pageIndex: 0,
    pageSize: DEFAULT_PAGE_SIZE
  }
};

class DealerService extends Service<IDealerContext> {
  constructor() {
    super();
    this.context = { ...defaultContext };
  }

  public setLoading = (loading: boolean) => {
    this.context.loading = loading;
  };

  public setSelectedTab = (tab: EDealerTab) => {
    this.context.selectedTab = tab;
  };

  public setLiveSymbolExposureMap = (map: Map<string, ICompanyExposurePositionMap>) => {
    this.context.allSymbolMap = map;
  };

  public setDisplayCompanyExposure = (companyExposure: ICompanyExposureRowData[]) => {
    this.context.displayCompanyExposure = companyExposure;
  };

  public setCompanyExposureSearchResult = (companyExposure: ICompanyExposureRowData[]) => {
    this.context.companyExposureSearchResult = companyExposure;
  };

  public setAllCompanyExposureData = (companyExposure: ICompanyExposureRowData[]) => {
    this.context.allCompanyExposure = companyExposure;

    if (this.context.search) {
      const searchResult = filterCompanyExposureBySearch(companyExposure, this.context.search);
      this.context.companyExposureSearchResult = searchResult;
    } else {
      this.context.companyExposureSearchResult = companyExposure;
    }
  };

  public setShowTypeFilter = (show: boolean) => {
    this.context.showTypeFilter = show;
  };

  public toggleShowTypeFilter = () => {
    this.context.showTypeFilter = !this.context.showTypeFilter;
  };

  public setCheckedTypes = (types: ECompanyExposureSymbolType[]) => {
    this.context.checkedTypes = types;
  };

  public setSearch = (search?: string) => {
    this.context.search = search;
  };

  public setPagination = (pageIndex: number, pageSize: number) => {
    this.context.pagination = { pageIndex, pageSize };
  };

  public reset = () => {
    this.context = { ...defaultContext };
  };
}

export default new DealerService();
